export default __webpack_public_path__ + "static/success-3ef6f3890875ef37c23935eaf7b1b8b6.svg";